import { Pipe, PipeTransform } from '@angular/core';
import { HostService } from '../../providers/host/host.service';

@Pipe({
  name: 'absolutePath'
})
export class AbsolutePathPipe implements PipeTransform {
  host:string;
  constructor(private hostService: HostService) {
    this.host = this.hostService.host2;
  }
  
  transform(value: string, args?: number): any {
    if(value){
      // return `${this.host}/${args}/${value}.webp`
      return `${this.host}/${args}/${value}`
    }else{
      return 'assets/imgs/no-dish.jpg'
    }
  }

}



// WEBPACK FOOTER //
// ./src/pipes/absolute-path/absolute-path.pipe.ts